import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { urlFor } from '../lib/imageBuilder';

export const ProjectCard = ({ project, index }) => {
  // Handle both Sanity images and static URLs
  const imageUrl = project.thumbnail?.asset 
    ? urlFor(project.thumbnail).width(800).height(600).url()
    : project.thumbnail;

  return (
    <motion.article
      className="group"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.5, 
        delay: index * 0.1,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      data-testid={`project-card-${project._id || project.id}`}
    >
      <Link to={`/work/${project.slug}`} className="block">
        {/* Image container */}
        <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-background-secondary mb-5">
          <img
            src={imageUrl}
            alt={project.title}
            className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
          />
          
          {/* Hover overlay */}
          <div className="absolute inset-0 bg-foreground-primary/0 group-hover:bg-foreground-primary/5 transition-colors duration-300" />
          
          {/* View project indicator */}
          <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-10 h-10 rounded-full bg-background-primary flex items-center justify-center shadow-lg">
              <ArrowUpRight className="w-4 h-4 text-foreground-primary" strokeWidth={1.5} />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-2">
          <p className="font-body text-xs text-accent-text uppercase tracking-wider">
            {project.category}
          </p>
          <h3 className="font-heading text-2xl lg:text-3xl text-foreground-primary group-hover:text-accent-hover transition-colors duration-200">
            {project.title}
          </h3>
          <p className="font-body text-sm text-foreground-secondary leading-relaxed line-clamp-2">
            {project.description}
          </p>
        </div>
      </Link>
    </motion.article>
  );
};

export default ProjectCard;
